// @ts-nocheck
import { createAuth } from '@websanova/vue-auth/src/v3.js';
import driverAuthJWT from './jwtDriver';
import driverHttpAxios from '@websanova/vue-auth/src/drivers/http/axios.1.x.js';
import driverRouterVueRouter from '@websanova/vue-auth/src/drivers/router/vue-router.2.x.js';

import router from '@/router';
import ssoAuth from '@/config/sso';

import type { RouteRecord } from 'vue-router';
import type { App } from 'vue';

export default (app: App<Element>) => {
  app.use(
    createAuth({
      plugins: {
        http: ssoAuth.createConnector(),
        router: router,
      },
      drivers: {
        auth: driverAuthJWT,
        http: driverHttpAxios, // Axios
        router: driverRouterVueRouter,
      },
      options: {
        rolesKey: 'type',
        notFoundRedirect: (transition: RouteRecord) => {
          if (transition.meta?.auth === false) {
            return {
              name: 'home',
            };
          }
          return { name: 'page-not-found' };
        },
        forbiddenRedirect: { name: 'login' },
        authRedirect: { name: 'login' },
        loginData: {
          url: '/token/',
          method: 'POST',
          redirect: '/',
          fetchUser: false,
          staySignedIn: true,
        },
        refreshData: {
          enabled:
            ssoAuth.isEnabled() &&
            !window.location.pathname.startsWith('/dev/impersonate'),
          url: '/token/',
          method: 'POST',
          interval: 10,
        },
        logoutData: {
          redirect: { name: 'login' },
          makeRequest: false,
        },
        fetchData: {
          // it's called automatically unless disabled
          enabled: false,
        },
        tokenDefaultKey: 'access_token',
        refreshTokenKey: 'refresh_token',
        staySignedInKey: 'auth_stay_signed_in', // need this or impersonate breaks
        stores: ['storage'],
        clientId: ssoAuth.extractClientFromToken(),
        clientSecret: ssoAuth.getClientKey(),
      },
    }),
  );
};
